import React from "react";
import { useSelector } from "react-redux";
import { Box, Flex } from "rebass";

import { getLeftSideWidth } from "../../../store/modules/display/selectors";

import { Library } from "../Library";
import { Record } from "../Record";
import { WidthControl } from "../WidthControl";

export const Home: React.FC = () => {
  const leftSideWidth = useSelector(getLeftSideWidth);

  return (
    <Flex height="100%">
      <WidthControl />

      <Box
        as="aside"
        flex={`0 0 ${leftSideWidth}%`}
        css="overflow: hidden;"
      >
        <Library />
      </Box>

      <Box flex={1}>
        <Record />
      </Box>
    </Flex>
  );
};
